import { reportClient } from 'api-clients';
import getSupplyChain from '../../supply-chain/services/get-supply-chain/get-supply-chain-service';

const dashboardService = {
  getSupplyChain: getSupplyChain(reportClient),
};

export default dashboardService;
